import './App.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FORMSPREE_ENDPOINT = process.env.REACT_APP_FORMSPREE_ENDPOINT || 'https://formspree.io/f/xeewkekj';

function Feedback() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim() || status === 'sending') return;

    setStatus('sending');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ message, email }),
      });
      setStatus(res.ok ? 'sent' : 'error');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="container">
      <h1>// Feedback</h1>
      <div className="profile-comment"># suggest a tool · report a bug · say hi</div>

      <div className="faq-content">
        <div className="faq-back">
          <button onClick={() => navigate('/')} className="back-button">
            ← Back to Home
          </button>
        </div>

        <div className="faq-item">
          {status === 'sent' ? (
            <p className="faq-answer feedback-status-ok"># thanks — your message was sent.</p>
          ) : (
            <form onSubmit={handleSubmit} className="feedback-form">
              <p className="faq-answer feedback-intro">
                Know a tool that should be listed, or spotted something broken? Tell me below.
              </p>

              <label className="feedback-label" htmlFor="feedback-message">message</label>
              <textarea
                id="feedback-message"
                className="feedback-textarea"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="your suggestion, tool request, or feedback…"
                rows={6}
                required
              />

              <label className="feedback-label" htmlFor="feedback-email">email <span className="feedback-optional">(optional — so I can reply)</span></label>
              <input
                id="feedback-email"
                type="email"
                className="steamid-input feedback-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
              />

              <div className="feedback-actions">
                <button type="submit" className="feedback-send" disabled={status === 'sending'}>
                  {status === 'sending' ? 'sending…' : '→ send'}
                </button>
                {status === 'error' && (
                  <span className="feedback-status-error"># something went wrong — please try again.</span>
                )}
              </div>
            </form>
          )}
        </div>
      </div>

      <div className="footer">
        <a href="/faq" className="faq-link">FAQ</a> • <a href="/privacy" className="faq-link">Privacy</a> • <a href="/feedback" className="faq-link">Feedback</a> • <a href="https://ko-fi.com/oddlobster" className="faq-link" target="_blank" rel="noopener noreferrer">Support me with ☕</a>
      </div>
    </div>
  );
}

export default Feedback;
